import {
  computed,
  IObservableArray,
  makeAutoObservable,
  observable,
} from "mobx";
import { ResourceTypeEnum } from "../../Enums/ResourceTypeEnum";
import ResourceServerClient from "../../ServerClients/ResourceServerClient";
import { ResourceResponseApi } from "../../DTO/ServerResponseType/Resource/Resource";

export class ResourcesStore {
  public resources: IObservableArray<ResourceResponseApi> = observable.array(
    []
  );
  public filterType: number = -1;

  constructor() {
    makeAutoObservable(this);
  }

  @computed get scenarios(): ResourceResponseApi[] {
    return this.resources.filter(
      (resource) => resource.resourceTypeId === ResourceTypeEnum.Scenario
    );
  }

  @computed get materials(): ResourceResponseApi[] {
    return this.resources.filter(
      (resource) =>
        resource.resourceTypeId === ResourceTypeEnum.MaterialForStudent
    );
  }

  @computed get resourcesWithoutScenarioAndMaterials(): ResourceResponseApi[] {
    return this.resources.filter(
      (resource) =>
        resource.resourceTypeId !== ResourceTypeEnum.MaterialForStudent &&
        resource.resourceTypeId !== ResourceTypeEnum.Scenario
    );
  }

  onChangeFilterType = (
    eventOrType: React.FormEvent<HTMLSelectElement> | number
  ): void => {
    if (typeof eventOrType === "number") this.filterType = eventOrType;
    else
      this.filterType = parseInt(
        eventOrType.currentTarget.options[
          eventOrType.currentTarget.selectedIndex
        ].value
      );
  };

  @computed
  get filteringResources(): ResourceResponseApi[] {
    if (this.filterType === -1)
      return this.resourcesWithoutScenarioAndMaterials;
    else
      return this.resources.filter(
        (resource) => resource.resourceTypeId === this.filterType
      );
  }

  selectedResource(
    event: React.FormEvent<HTMLSelectElement>
  ): ResourceResponseApi | undefined {
    let eventOption =
      event.currentTarget.options[event.currentTarget.selectedIndex];

    if (eventOption)
      return this.resources.find(
        (resource) => resource.resourceId === eventOption.value
      );
  }

  setResources = (resources: ResourceResponseApi[]) => {
    this.resources.replace(resources);
  };

  public loadAllResourcesAsync = async (): Promise<
    ResourceResponseApi[] | never
  > => {
    return ResourceServerClient.sendToGetAllResourcesAsync().then(
      (resources) => {
        this.setResources(resources);
        return resources;
      }
    );
  };
}
